import styled from "styled-components";

import { ChartLabelOpenNewWindowWrapper } from "../../StyledComponents";

interface ChannelsOverviewCategoryLabelProps {
    categoryKey: string;
    label: string;
    tooltip: string;
    href?: string | null;
}

// CJK Symbols & Punctuation, Hiragana, Katakana, CJK Unified Ideographs, Hangul Syllables.
const CJK_REGEX = /[\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FFF\uAC00-\uD7AF]/;
const hasCJK = (text: string): boolean => CJK_REGEX.test(text);

const LatinLinkLabel = styled.a`
    display: inline-block;
    text-align: center;
    line-height: 1.25;
    white-space: nowrap !important;
`;

const LatinTextLabel = styled.span`
    display: inline-block;
    text-align: center;
    line-height: 1.25;
    white-space: nowrap !important;
`;

/**
 * CJK labels need a fixed slot + line clamp so the engine wraps them instead of
 * collapsing to one character per line.
 */
const CjkLinkLabel = styled.a`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 110px;
    text-align: center;
    line-height: 1.25;
    white-space: normal;
    overflow-wrap: break-word;
`;

const CjkTextLabel = styled.span`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 110px;
    text-align: center;
    line-height: 1.25;
    white-space: normal;
    overflow-wrap: break-word;
`;

export const ChannelsOverviewCategoryLabel = ({
    categoryKey,
    href,
    label,
    tooltip,
}: ChannelsOverviewCategoryLabelProps) => {
    const isCJK = hasCJK(label);
    const Link = isCJK ? CjkLinkLabel : LatinLinkLabel;
    const Text = isCJK ? CjkTextLabel : LatinTextLabel;

    if (href) {
        return (
            <ChartLabelOpenNewWindowWrapper>
                <Link
                    href={href}
                    data-ts-category={categoryKey}
                    title={tooltip}
                >
                    {label}
                </Link>
            </ChartLabelOpenNewWindowWrapper>
        );
    }

    return (
        <Text
            data-ts-category={categoryKey}
            title={tooltip}
        >
            {label}
        </Text>
    );
};
